import React, { Component } from 'react';
import {Col, Row} from 'react-bootstrap';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Tooltip from '@mui/material/Tooltip';
import Modal from '../../../components/modal';
import Preloader from '../../../components/preloader';
import EmptyState from '../../../components/empty-state-container';
import AccessForbidden from '../../../components/access-forbidden-container';

import IconMenu from '@mui/icons-material/Menu';
import MenuItem from '@mui/material/MenuItem';
import IconButton from '@mui/material/IconButton';

import {connect} from 'react-redux';

let contextList;

class ManageContext extends Component {

  constructor(props) {
    super(props);
    this.state = {
      dbFilterCriteria:"",
      emptyState:"You do not have any Context Setup.",
      deleteVal:"",
      modalOpen:false,
      modalTitle:"",
      modalContent:"",
      modalPrimaryButton:"",
      modalSecondaryButton:""
    };
  }


componentDidMount=()=>{
  this.setState({
    dbFilterCriteria:""
  });
}




editContext = (context) => {
    this.props.onClick({context});
}

modalClose=()=>{
  this.setState({
    modalOpen:false
  });
}

modalConfirm=()=>{

  this.setState({
    modalOpen:false
  });
  let deleteObj={
      id:this.state.deleteVal.connId,
      name: this.state.deleteVal.name
  }
  this.props.deleteContext(deleteObj);
}

deleteItem = (item) => {
    //this.props.getRuleSetContent(value);
    //this.props.onClick(value);
    this.setState({
      modalOpen:true,
      modalTitle:"Delete Context",
      modalContent:"Are you sure you want to delete \""+item.name+"\"?",
      modalPrimaryButton:"Yes",
      modalSecondaryButton:"No",
      modalState:"delete",
      deleteVal:item
    });
}

  createNewContext = () => {
    this.props.onClick('new');
}





   render() {






     const {isLoading} = this.props;
     let manageContent,contextListContent;

     if(isLoading.includes('contextlist')){
       manageContent=<Preloader loading={true} /> ;
     }
     else if(this.props.contextList !== undefined){

      if(this.props.contextList===false){
        manageContent=<AccessForbidden message="Sorry, you don't have access to this. Please contact your admin." />
      } else{
      const filterCriteria=this.state.dbFilterCriteria;
      contextList = this.props.contextList.filter(function (e) {  return e.contextName.toLowerCase().includes(filterCriteria.toLowerCase()); } );


      if(contextList.length>0){
        contextListContent=<table className='manage-ruleset-table'>
        <tbody>
             {contextList.map((context,index) => <tr key={index}>
               <td onClick={this.editContext.bind(this,context)} className='user' >{context.contextName}</td>
               <td>{context.desc}</td>
               <td>
               <IconMenu
                   iconButtonElement={<IconButton size="large"><i className='material-icons'>more_horiz</i></IconButton>}
                   anchorOrigin={{horizontal: 'right', vertical: 'top'}}
                   targetOrigin={{horizontal: 'right', vertical: 'top'}}
                   className='actions-menu hide'
                 >
                   <MenuItem
                   primaryText="Delete"
                   className='wl-group-card-menu'
                   onClick={this.deleteItem.bind(this,context)}  />
               </IconMenu>
                </td>
               </tr>)}
       </tbody>
        </table>
      }else{
        contextListContent=<EmptyState className="margin-top-0" message={this.state.emptyState} />
      }
       manageContent=<Row>

       <Col sm={6} xs={6}>{contextListContent}</Col>
       <Col sm={4} xs={6} className="manage-rule-buttons">

          <Button href=""  onClick={this.createNewContext.bind(this)} label="Add a new context" className='createruleset-button'></Button>
       </Col>

       </Row>
     }
   }

     return (
       <div>
       <Modal
        open={this.state.modalOpen}
        title={this.state.modalTitle}
        content={this.state.modalContent}
        primaryButton={this.state.modalPrimaryButton}
        secondaryButton={this.state.modalSecondaryButton}
        close={this.modalClose}
        confirm={this.modalConfirm}
        />
       <div className="manage-ruleset margin-top-30">

       {manageContent}

       </div>

         </div>

     );
   }
}


const mapStateToProps = (state) => {
  return{
    errors: state.contextReducer.errorMessage
  };
};

export const mapDispatchToProps = (dispatch) => {
  return {

  }
}


export default connect(mapStateToProps,mapDispatchToProps) (ManageContext);
